<template>
  <div>
    <table-list
      title="考试计划"
      :loading="loading"
      :search-form="searchForm(this)"
      :data="examPlanList"
      :btns="btns(this)"
      :footer-btns="footerBtns(this)"
      :columns="columns(this)"
      :operates="operates(this)"
      :pager="pager"
      :options="{ selection: true, operatesWidth: 250 }"
      :span-method="objectSpanMethod"
      :row-class-name="rowClass"
      @search="onSearch"
      @selectionChange="handleSelectionChange"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></table-list>
  </div>
</template>
<script>
// 顶部按钮
const btns = _this => [
  {
    label: '增加',
    icon: 'el-icon-circle-plus-outline',
    method: _this.handleAdd,
  },
]
// 底部按钮
const footerBtns = _this => [
  {
    label: '导出全部',
    icon: 'el-icon-download',
    method: _this.exportTable,
  },
]
// 搜索框配置
const searchForm = _this => [
  {
    label: 'ID/考试计划/考试科目',
    prop: 'keyWord',
  },
  {
    label: '职业',
    type: 'select',
    prop: 'jobId',
    children: _this.jobLevelList.map(item => ({
      value: item.id,
      label: item.jobName,
    })),
  },
  {
    label: '类型',
    type: 'select',
    prop: 'subjectType',
    children: [
      { value: '2', label: '理论' },
      { value: '1', label: '实操' },
    ],
  },
  {
    label: '状态',
    type: 'select',
    prop: 'isPublish',
    children: [
      { value: '0', label: '编辑中' },
      { value: '1', label: '已发布' },
      { value: '2', label: '已结束' },
    ],
  },
  {
    label: '创建时间',
    type: 'picker',
    placeholder: '创建时间',
    prop: 'createTime',
  },
  {
    label: '考试时间',
    type: 'picker',
    placeholder: '考试时间',
    prop: 'examTime',
  },
  {
    label: '创建人',
    type: 'select',
    prop: 'createUserId',
    children: _this.adminList.map(item => ({
      value: item.key,
      label: item.value,
    })),
  },
]
// 表格列配置
const columns = () => [
  {
    prop: 'id',
    label: 'ID',
    minWidth: 60,
  },
  {
    prop: 'examPlanName',
    label: '考试计划名称',
    minWidth: 200,
    twoLines: true,
  },
  {
    prop: 'subjectTypeName',
    label: '类型',
    minWidth: 50,
  },
  {
    prop: 'examSubjectName',
    label: '科目名称',
    minWidth: 200,
    twoLines: true,
  },
  {
    prop: 'subjectJobName',
    label: '职业',
    minWidth: 120,
  },
  {
    prop: 'subjectJobLevel',
    label: '等级',
    minWidth: 50,
  },
  {
    prop: 'questionCount',
    label: '试题数',
    minWidth: 70,
  },
  {
    prop: 'examCount',
    label: '考试人数',
    minWidth: 80,
  },
  {
    prop: 'successCount',
    label: '完成人数',
    minWidth: 80,
  },
  {
    label: '考试时间',
    minWidth: 210,
    render: (h, { row }) => {
      return [
        row.subjectExamBeginTime
          ? h(
              'div',
              {
                style: {
                  display: 'flex',
                  alignItems: 'center',
                },
              },
              [
                h('img', {
                  style: {
                    marginRight: '3px',
                  },
                  domProps: { src: require('@/assets/start.png') },
                }),
                h('span', row.subjectExamBeginTime),
              ],
            )
          : null,
        row.subjectExamEndTime
          ? h(
              'div',
              {
                style: {
                  display: 'flex',
                  alignItems: 'center',
                },
              },
              [
                h('img', {
                  style: {
                    marginRight: '3px',
                  },
                  domProps: { src: require('@/assets/end.png') },
                }),
                h('span', row.subjectExamEndTime),
              ],
            )
          : null,
      ]
    },
  },
  {
    prop: 'userName',
    label: '创建人',
    minWidth: 70,
  },
  {
    prop: 'createTime',
    label: '创建时间',
    minWidth: 150,
  },
  {
    prop: 'isPublish',
    label: '状态',
    minWidth: 70,
    formatter: row => {
      return ['编辑中', '已发布', '已结束'][row.isPublish]
    },
  },
]
// 表格操作按钮配置
const operates = _this => [
  {
    method: _this.handlePublish,
    label: '发布',
    isShow: item => item.isPublish == 0,
  },
  {
    method: _this.handleUnPublish,
    label: '取消发布',
    isShow: item =>
      item.isPublish == 1 && Date.parse(new Date(item.examStartTime)) > Date.parse(new Date()),
  },
  {
    method: _this.handleStop,
    label: '考试结束',
    isShow: item =>
      item.isPublish == 1 && Date.parse(new Date(item.examStartTime)) < Date.parse(new Date()),
  },
  {
    method: _this.handleEdit,
    label: '编辑',
    isShow: item => item.isPublish == 0,
  },
  {
    method: _this.handleRead,
    label: '查看',
    isShow: item => item.isPublish == 1 || item.isPublish == 2,
  },
  {
    method: _this.handleResult,
    label: '成绩统计',
  },
  {
    method: _this.handleDelete,
    label: '删除',
  },
]
import TableList from '@/components/TableList'
import {
  examPlanList,
  examPlanRemove,
  filterJobLevel,
  addExamPlan,
  filterAdminList,
  examPlanPublish,
  examPlanUnPublish,
  examPlanStop,
  examPlanExport,
  examPlanPublishRemove,
} from '@/api/exam'
import to from 'await-to'
import { mapGetters } from 'vuex'
export default {
  name: 'ExamItems',
  components: {
    TableList,
  },
  data() {
    return {
      searchForm,
      btns,
      footerBtns,
      columns,
      operates,
      loading: false,
      examPlanList: [],
      selectList: [],
      pager: {
        total: 0,
        size: 20,
        current: 1,
      },
      queryParams: {},
      mergeIDList: [],
      adminList: [],
      jobLevelList: [],
    }
  },
  computed: {
    ...mapGetters(['userId']),
  },
  mounted() {
    this.getExamPlanList()
    this.getAdminList()
    this.getJobLevel()
  },
  methods: {
    async getExamPlanList() {
      if (this.loading) return
      const { current, size } = this.pager
      this.loading = true
      const [res, err] = await to(examPlanList({ current, size, ...this.queryParams }))
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.examPlanList = res.data.list
      this.pager.total = res.data.total
      this.mergeData()
    },
    async getAdminList() {
      const [res, err] = await to(filterAdminList({}))
      if (err) return this.$message.warning(err.msg)
      this.adminList = res.data
    },
    async getJobLevel() {
      const [res, err] = await to(filterJobLevel({}))
      if (err) return this.$message.warning(err.msg)
      this.jobLevelList = res.data
      console.log(this.jobLevelList)
    },
    //导出
    async exportTable() {
      let arr = []
      console.log(this.selectList)
      if (this.selectList.length) this.selectList.map(v => arr.push(v.id))
      const { current, size } = this.pager
      const [res, err] = await to(
        examPlanExport({
          current,
          size,
          ids: arr,
          ...this.queryParams,
        }),
      )
      if (err) return this.$message.warning(err.msg)
      let blob = new Blob([res], {
        type: 'application/vnd.ms-excel',
      })
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = '考试计划.xlsx'
      a.click()
      window.URL.revokeObjectURL(url)
    },
    // 查询按钮
    onSearch(queryParams) {
      this.pager.current = 1
      this.queryParams = queryParams
      if (queryParams.createTime && queryParams.createTime.length) {
        queryParams.createStartTime = queryParams.createTime[0]
        queryParams.createEndTime = queryParams.createTime[1].split(' ')[0] + ' 23:59:59'
      } else {
        queryParams.createStartTime = undefined
        queryParams.createEndTime = undefined
      }
      if (queryParams.examTime && queryParams.examTime.length) {
        queryParams.examStartTime = queryParams.examTime[0]
        queryParams.examEndTime = queryParams.examTime[1].split(' ')[0] + ' 23:59:59'
      } else {
        queryParams.examStartTime = undefined
        queryParams.examEndTime = undefined
      }
      this.getExamPlanList()
    },
    // 编辑
    handleEdit(row) {
      this.$router.push({ path: `/exam/plan/${row.id}` })
    },
    handleRead(row) {
      this.$router.push({ path: `/exam/plan/read/${row.id}` })
    },
    handleResult(row) {
      this.$router.push({ path: '/exam/result', query: { planId: row.id } })
    },
    // 删除
    async handleDelete(row) {
      this.$confirm(
        `您确定要删除${row.examPlanName || '该'}考试计划吗？删除后将无法恢复`,
        '确认删除',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        },
      )
        .then(async () => {
          if (row.isPublish == 0) {
            const [, err] = await to(examPlanRemove({ id: row.id }))
            if (err) return this.$message.warning(err.msg)
            this.$message.success('删除成功')
            this.getExamPlanList()
          } else {
            const [, err] = await to(examPlanPublishRemove({ planId: row.id }))
            if (err) return this.$message.warning(err.msg)
            this.$message.success('删除成功')
            this.getExamPlanList()
          }
        })
        .catch(() => {})
    },
    async handleAdd() {
      const [res, err] = await to(addExamPlan({}))
      if (err) return this.$message.warning(err.msg)
      this.$router.push({ path: `/exam/plan/${res.data}` })
    },
    async handlePublish(row) {
      const [, err] = await to(examPlanPublish({ id: row.id }))
      if (err) return this.$message.warning(err.msg)
      this.$message.success('发布成功')
      this.getExamPlanList()
    },
    async handleUnPublish(row) {
      const [, err] = await to(examPlanUnPublish({ id: row.id }))
      if (err) return this.$message.warning(err.msg)
      this.$message.success('取消发布成功')
      this.getExamPlanList()
    },
    async handleStop(row) {
      this.$confirm(
        `您确定要${row.examPlanName}考试计划操作结束吗？操作后计划将直接结束`,
        '确认结束',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        },
      )
        .then(async () => {
          const [, err] = await to(examPlanStop({ id: row.id }))
          if (err) return this.$message.warning(err.msg)
          this.$message.success('结束考试成功')
          this.getExamPlanList()
        })
        .catch(() => {})
    },
    // 分页
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.getExamPlanList()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.getExamPlanList()
    },
    handleSelectionChange(val) {
      this.selectList = val
    },
    mergeData() {
      this.mergeIDList = []
      let i = 0
      this.examPlanList.forEach((item, index) => {
        if (index === 0) {
          // 第一行必须存在
          this.mergeIDList.push(1)
          i = 0
        } else {
          if (item.id === this.examPlanList[index - 1].id) {
            this.mergeIDList[i]++
            this.mergeIDList.push(0)
          } else {
            this.mergeIDList.push(1)
            i = index
          }
        }
      })
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      const MergeColIndex = [0, 1, 2, 11, 12, 13, 14] // 全部合并的一级列
      if (MergeColIndex.includes(columnIndex)) {
        const colNum = this.mergeIDList[rowIndex]
        return {
          rowspan: colNum, // n行单元格的第一个直接占满n行
          colspan: colNum > 0 ? 1 : 0,
        }
      }
    },
    rowClass({ rowIndex }) {
      var classList = []
      let i = 0
      this.examPlanList.forEach((item, index) => {
        if (index === 0) {
          classList.push('odd-row')
          i = 0
        } else {
          if (item.id === this.examPlanList[index - 1].id) {
            classList.push(classList[i])
          } else {
            if (classList[i] == 'odd-row') {
              classList.push('even-row')
            } else {
              classList.push('odd-row')
            }
            i = index
          }
        }
      })
      return classList[rowIndex]
    },
  },
}
</script>
<style lang="scss" scoped>
/deep/ .el-table {
  .even-row {
    background-color: #fff;
  }
  .odd-row {
    .el-table__cell {
      background-color: #fafafa !important;
    }
  }
  .red {
    color: #ed5327;
  }
}
</style>
